var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendeTuAutoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.528 11.664l-7.2-7.2A1.59 1.59 0 0011.2 4H5.6C4.72 4 4 4.72 4 5.6v5.6c0 .44.176.84.472 1.136l7.2 7.2A1.59 1.59 0 0012.8 20c.44 0 .84-.176 1.128-.472l5.6-5.6c.296-.288.472-.688.472-1.128 0-.44-.184-.848-.472-1.136zM6.8 8c-.664 0-1.2-.536-1.2-1.2 0-.664.536-1.2 1.2-1.2.664 0 1.2.536 1.2 1.2C8 7.464 7.464 8 6.8 8z",
    fill: "#0A111E"
  })));
}
export default SvgVendeTuAutoIcon;